module.exports = __webpack_public_path__ + "images/demo/dummy_img_f8c0367b90908b95599208715b91e28f.jpg";